import React from 'react';
import { API_BASE, toUrl } from '../lib/config';

type Row = {
  id: string;
  orderIndex: number;
  title: string;
  description: string;
  isActive: boolean;
  updatedAt: string;
};

const FeatureHakkimizdaYonetim: React.FC = () => {

  const [items, setItems] = React.useState<Row[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [q, setQ] = React.useState('');

  const [editingId, setEditingId] = React.useState('');
  const [eTitle, setETitle] = React.useState('');
  const [eDesc, setEDesc] = React.useState('');
  const [eOrder, setEOrder] = React.useState<number>(0);
  const [eActive, setEActive] = React.useState(true);
  const [saving, setSaving] = React.useState(false);

  const [delId, setDelId] = React.useState('');
  const [delLoading, setDelLoading] = React.useState(false);

  const fetchAll = React.useCallback(async () => {
    try {
      setLoading(true); setError('');
      const res = await fetch(toUrl('/api/feature-hakkimizda/admin'));
      if (!res.ok) throw new Error('Kayıtlar alınamadı');
      const data = await res.json();
      setItems(data || []);
    } catch (e: any) { setError(e.message || 'Beklenmeyen bir hata oluştu'); }
    finally { setLoading(false); }
  }, []);

  React.useEffect(() => { fetchAll(); }, [fetchAll]);

  const filtered = React.useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return items;
    return items.filter(i => (i.title || '').toLowerCase().includes(t) || (i.description || '').toLowerCase().includes(t));
  }, [items, q]);

  const openEdit = (row: Row) => {
    setEditingId(row.id);
    setETitle(row.title || '');
    setEDesc(row.description || '');
    setEOrder(row.orderIndex || 0);
    setEActive(!!row.isActive);
  };
  const cancelEdit = () => { setEditingId(''); setETitle(''); setEDesc(''); setEOrder(0); setEActive(true); };
  const onSave = async (id: string) => {
    if (!eTitle.trim() || !eDesc.trim()) { setError('Lütfen başlık ve açıklama girin'); return; }
    try {
      setSaving(true); setError('');
      const body: any = { title: eTitle.trim(), description: eDesc.trim(), orderIndex: eOrder || 0, isActive: !!eActive };
      const res = await fetch(toUrl(`/api/feature-hakkimizda/admin/${id}`), { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
      if (!res.ok) throw new Error('Güncelleme başarısız');
      cancelEdit(); await fetchAll();
    } catch (e: any) { setError(e.message || 'Beklenmeyen bir hata oluştu'); }
    finally { setSaving(false); }
  };

  const onDelete = (id: string) => setDelId(id);
  const confirmDelete = async () => {
    if (!delId) return;
    try {
      setDelLoading(true);
      const res = await fetch(toUrl(`/api/feature-hakkimizda/admin/${delId}`), { method: 'DELETE' });
      if (!res.ok) throw new Error('Silme başarısız');
      setDelId(''); await fetchAll();
    } catch (e: any) { setError(e.message || 'Beklenmeyen bir hata oluştu'); }
    finally { setDelLoading(false); }
  };

  return (
    <div className="admin-page" style={{ padding: 12 }}>
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', marginBottom: 12 }}>
        <h2 style={{ margin: 0 }}>Feature Hakkımızda</h2>
        <div style={{ fontSize: 12, color: '#6b7280' }}>Toplam: {items.length}</div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <div style={{ padding: 12, display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <input type="text" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Ara: başlık, açıklama" className="input" style={{ width: 300 }} />
            {q && <button onClick={() => setQ('')} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer' }}>Temizle</button>}
          </div>
          <button onClick={fetchAll} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer' }}>Yenile</button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f3f4f6' }}>
                <th style={{ textAlign: 'left', padding: '12px 16px' }}>Sıra</th>
                <th style={{ textAlign: 'left', padding: '12px 16px' }}>Başlık</th>
                <th style={{ textAlign: 'left', padding: '12px 16px' }}>Açıklama</th>
                <th style={{ textAlign: 'left', padding: '12px 16px' }}>Aktif</th>
                <th style={{ textAlign: 'left', padding: '12px 16px' }}>Güncellenme</th>
                <th style={{ textAlign: 'right', padding: '12px 16px' }}>İşlemler</th>
              </tr>
            </thead>
            <tbody>
              {loading && (<tr><td colSpan={6} style={{ padding: 16, color: '#6b7280' }}>Yükleniyor...</td></tr>)}
              {!loading && filtered.length === 0 && (<tr><td colSpan={6} style={{ padding: 16, color: '#6b7280' }}>Kayıt bulunamadı.</td></tr>)}
              {filtered.map(row => (
                <tr key={row.id} style={{ borderTop: '1px solid #e5e7eb' }}>
                  <td style={{ padding: '12px 16px', width: 120 }}>
                    {editingId === row.id ? (
                      <input className="input" type="number" value={eOrder} onChange={(e) => setEOrder(parseInt(e.target.value || '0', 10))} />
                    ) : row.orderIndex}
                  </td>
                  <td style={{ padding: '12px 16px', minWidth: 220 }}>
                    {editingId === row.id ? (
                      <input className="input" value={eTitle} onChange={(e) => setETitle(e.target.value)} />
                    ) : row.title}
                  </td>
                  <td style={{ padding: '12px 16px', minWidth: 280 }}>
                    {editingId === row.id ? (
                      <textarea className="input" rows={3} value={eDesc} onChange={(e) => setEDesc(e.target.value)} />
                    ) : row.description}
                  </td>
                  <td style={{ padding: '12px 16px', width: 160 }}>
                    {editingId === row.id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input id={`act-${row.id}`} type="checkbox" checked={eActive} onChange={(e) => setEActive(e.target.checked)} />
                        <label htmlFor={`act-${row.id}`}>Aktif</label>
                      </div>
                    ) : (
                      <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 999, fontSize: 12, background: row.isActive ? '#ecfdf5' : '#fef2f2', color: row.isActive ? '#065f46' : '#991b1b', border: `1px solid ${row.isActive ? '#a7f3d0' : '#fecaca'}` }}>{row.isActive ? 'Aktif' : 'Pasif'}</span>
                    )}
                  </td>
                  <td style={{ padding: '12px 16px' }}>{row.updatedAt ? new Date(row.updatedAt).toLocaleString() : '-'}</td>
                  <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                    {editingId === row.id ? (
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                        <button onClick={() => onSave(row.id)} disabled={saving} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #16a34a', background: '#16a34a', color: '#fff', cursor: 'pointer', opacity: saving ? 0.8 : 1 }}>{saving ? 'Kaydediliyor...' : 'Kaydet'}</button>
                        <button onClick={cancelEdit} disabled={saving} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer' }}>İptal</button>
                      </div>
                    ) : (
                      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                        <button onClick={() => openEdit(row)} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #2563eb', background: '#fff', color: '#2563eb', cursor: 'pointer' }}>Düzenle</button>
                        <button onClick={() => onDelete(row.id)} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #dc2626', background: '#dc2626', color: '#fff', cursor: 'pointer' }}>Sil</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Delete confirm modal */}
      {delId && (
        <div role="dialog" aria-modal="true" aria-labelledby="delTitle" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1050 }} onClick={(e) => { if (e.target === e.currentTarget) setDelId(''); }} onKeyDown={(e) => { if (e.key === 'Escape') setDelId(''); }} tabIndex={-1}>
          <div onClick={(e) => e.stopPropagation()} style={{ width: 'min(480px,92vw)', background: '#fff', borderRadius: 12, boxShadow: '0 10px 25px rgba(0,0,0,0.15)', overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', borderBottom: '1px solid #e5e7eb', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <h5 id="delTitle" style={{ margin: 0, fontSize: 18 }}>Silme Onayı</h5>
              <button type="button" aria-label="Close" onClick={() => setDelId('')} style={{ background: 'transparent', border: 0, fontSize: 18, lineHeight: 1, cursor: 'pointer', color: '#6b7280' }}>×</button>
            </div>
            <div style={{ padding: 16 }}>Bu kaydı silmek istediğinize emin misiniz? Bu işlem geri alınamaz.</div>
            <div style={{ padding: 12, borderTop: '1px solid #e5e7eb', display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button type="button" onClick={() => setDelId('')} disabled={delLoading} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #d1d5db', background: '#fff', color: '#374151', cursor: 'pointer' }}>İptal</button>
              <button type="button" onClick={confirmDelete} disabled={delLoading} style={{ padding: '8px 12px', borderRadius: 8, border: '1px solid #dc2626', background: '#dc2626', color: '#fff', cursor: 'pointer', opacity: delLoading ? 0.8 : 1 }}>{delLoading ? 'Siliniyor...' : 'Evet, Sil'}</button>
            </div>
          </div>
        </div>
      )}

      {error && <div style={{ marginTop: 8, color: '#b00020' }}>{error}</div>}
    </div>
  );
};

export default FeatureHakkimizdaYonetim;
